import React, {Component} from 'react';
import {  AuthenticatedUser, reviseTUser, isAfterDate } from "../../../api";

class TUserBox extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        this.onExpandedChanged = this.onExpandedChanged.bind(this);

        var expanded = this.props.tUser[this.props.controlKey];
        if (!this.props.tUser || this.props.tUser.userId === "0") {
            if(isAfterDate(new Date(), new Date(this.props.tData.endDate))) {
                expanded = false; 
            } else expanded = true;
        } else if (this.props.tUser && typeof this.props.tUser[this.props.controlKey] === 'undefined') expanded = true;

        this.state = {
            loading: true,
            user: user,
            tData: this.props.tData,
            expanded: expanded
        }

    }
    
    onExpandedChanged() {
        const {tUser} = this.props;
        tUser[this.props.controlKey] = !this.state.expanded;
        reviseTUser(tUser);

        this.setState({expanded: !this.state.expanded})
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if(prevProps !== this.props) {
  
        }
    }

    render() {
        //const {tData, tUser} = this.props;
        var isOpen = this.state.expanded;

        return (    
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header" style={{backgroundColor: "#5d7227", paddingTop: "10px", paddingBottom: "4px", marginBottom: "0px", marginTop: "4px"}}>
                    <div className="row">
                        <div className="col-6"><h4 style={{color: "white"}}>{this.props.title}</h4></div>                   
                            <div className="col-6">
                                <div  className="pull-right">
                                    <span style={{cursor: "pointer"}} onClick={this.onExpandedChanged}><h4 style={{color: "white"}}>{isOpen ? "Collapse" : "Expand"}</h4></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body"  style={{backgroundColor: this.props.bg ? this.props.bg : "lightgray", paddingTop: "0px", paddingBottom: "0px", marginTop: "0px", marginBottom: "0px"}}>
                        { isOpen &&
                        <div className="container-fluid" style={{paddingTop: "10px"}} >
                            {this.props.children}
                        </div>
                        }
                    </div>
                    <div className="card-footer" style={{backgroundColor: "#5d7227", paddingTop: "4px", paddingBottom: "4px"}}>
                    </div>
                </div>            
            </div>                           
        )
    }
}

export default TUserBox;